<template>
  <v-row class="ma-0">
    <v-col
      v-for="{ component, props, key } in items"
      :key="key"
      cols="12"
      :xl="xl"
      :lg="lg"
      :md="md"
      :sm="sm"
      :xs="xs"
    >
      <component :is="component" v-bind="props" :data-testid="`card-${key}`" />
    </v-col>
  </v-row>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true
  },
  xl: {
    type: [String, Number],
    default: "3"
  },
  lg: {
    type: [String, Number],
    default: "3"
  },
  md: {
    type: [String, Number],
    default: "4"
  },
  sm: {
    type: [String, Number],
    default: "6"
  },
  xs: {
    type: [String, Number],
    default: "6"
  },
  cols: {
    type: [String, Number],
    default: "12"
  }
});
</script>
